import { derived, writable } from "svelte/store"
import { darkmodePreference } from "@store/deviceSettings"
import { updateHtmlClass } from "@utils/directives/useCSSObserver"

export type DarkModeOptions = "auto" | "light" | "dark"

const systemDarkmode = writable(
    window.matchMedia &&
        window.matchMedia("(prefers-color-scheme: dark)").matches
)
window
    .matchMedia("(prefers-color-scheme: dark)")
    .addEventListener("change", (e) => systemDarkmode.set(e.matches))

export const darkmode = derived(
    [darkmodePreference, systemDarkmode],
    ([preference, system]) => {
        switch (preference) {
            case "light": {
                return false
                break
            }
            case "dark": {
                return true
                break
            }
            default: {
                return system
                break
            }
        }
    }
)

darkmode.subscribe((dark) => updateHtmlClass("darkmode", dark))
